<template>
  <div class="content_box risk">
    <!-- 工具栏 插槽-->
    <div class="header" style="background: #1290c9">
      <Header @onSearch="onSearch" :themeColor="'#1290C9'">
        <!-- 工具栏 -->
        <Tollbar
          class="header_menu_box"
          :list="tollbarList"
          :sortList="sortList"
          :conditionsList="conditionsList"
          :selectList="selectList"
          :isShowExport="false"
          type="1"
          theme="1"
          :isShowSearch.sync="isShowSearch"
          :isShowSelect.sync="isShowSelect"
          @onClearSearch="clearParams"
          @onChangeSort="onChangeSort"
          @onExport="onExport"
        ></Tollbar>
      </Header>
    </div>
    <!-- 页面部分 -->
    <div class="content_wrap">
      <div class="wrap_search_box" v-show="isShowSearch">
        <el-collapse v-model="openMenu" ref="collapseItem">
          <el-collapse-item
            :title="$t('RiskScan.LastUpdate')"
            name="1"
            class="first_item"
          >
            <template slot="title">
              <span>{{ $t("RiskScan.LastUpdate") }}</span>
              <span class="clear_all" @click.stop="clearParams">
                <i class="iconfont icon-qingchu" />{{ $t("RiskScan.ClearAll") }}
              </span>
            </template>
            <el-select
              clearable
              v-model="searchParams.updateDate"
              filterable
              popper-class="new-search-select"
              :popper-append-to-body="true"
              :disabled="selectDisabled"
              :placeholder="$t('RiskScan.Selectdate')"
              @change="(val) => onChangeParams(val, 'updateDate')"
            >
              <el-option
                v-for="(item, index) in UpdateDateList"
                :key="index"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-collapse-item>
          <el-collapse-item :title="$t('RiskScan.UpdateStatus')" name="2">
            <el-radio-group
              v-model="searchParams.updateFlag"
              @change="(val) => onChangeParams(val, 'updateFlag')"
            >
              <el-radio label="1">{{ $t("RiskScan.ALL") }}</el-radio>
              <el-radio label="2">{{ $t("RiskScan.Updated") }}</el-radio>
              <el-radio label="3">{{ $t("RiskScan.Notupdated") }}</el-radio>
            </el-radio-group>
          </el-collapse-item>
          <el-collapse-item :title="$t('RiskScan.LegalRisk')" name="3">
            <el-select
              clearable
              multiple
              v-model="searchParams.legalRisk"
              filterable
              popper-class="new-search-select"
              :popper-append-to-body="true"
              :disabled="selectDisabled"
              :placeholder="$t('RiskScan.Selectrisklevel')"
              @change="(val) => onChangeParams(val, 'legalRisk')"
            >
              <el-option
                v-for="(item, index) in legalRiskList"
                :key="item.label"
                :label="showDotText(item.label) + '  (' + item.value + ')'"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-collapse-item>
          <el-collapse-item :title="$t('RiskScan.OrganizationalRisk')" name="4">
            <el-select
              clearable
              multiple
              v-model="searchParams.organizationalRisk"
              filterable
              popper-class="new-search-select"
              :popper-append-to-body="true"
              :disabled="selectDisabled"
              :placeholder="$t('RiskScan.Selectrisklevel')"
              @change="(val) => onChangeParams(val, 'organizationalRisk')"
            >
              <el-option
                v-for="(item, index) in organizationalRiskList"
                :key="item.label"
                :label="showDotText(item.label) + '  (' + item.value + ')'"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-collapse-item>
          <el-collapse-item :title="$t('RiskScan.OperationalRisk')" name="5">
            <el-select
              clearable
              multiple
              v-model="searchParams.operationalRisk"
              filterable
              popper-class="new-search-select"
              :popper-append-to-body="true"
              :disabled="selectDisabled"
              :placeholder="$t('RiskScan.Selectrisklevel')"
              @change="(val) => onChangeParams(val, 'operationalRisk')"
            >
              <el-option
                v-for="(item, index) in operationalRiskList"
                :key="item.label"
                :label="showDotText(item.label) + '  (' + item.value + ')'"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-collapse-item>
          <el-collapse-item :title="$t('RiskScan.FinancialRisk')" name="6">
            <el-select
              clearable
              multiple
              v-model="searchParams.financialRisk"
              filterable
              popper-class="new-search-select"
              :popper-append-to-body="true"
              :disabled="selectDisabled"
              :placeholder="$t('RiskScan.Selectrisklevel')"
              @change="(val) => onChangeParams(val, 'financialRisk')"
            >
              <el-option
                v-for="(item, index) in financialRiskList"
                :key="item.label"
                :label="showDotText(item.label) + '  (' + item.value + ')'"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-collapse-item>
          <el-collapse-item :title="$t('RiskScan.CreditRisk')" name="7">
            <el-select
              clearable
              multiple
              v-model="searchParams.creditRisk"
              filterable
              popper-class="new-search-select"
              :popper-append-to-body="true"
              :disabled="selectDisabled"
              :placeholder="$t('RiskScan.Selectrisklevel')"
              @change="(val) => onChangeParams(val, 'creditRisk')"
            >
              <el-option
                v-for="(item, index) in creditRiskList"
                :key="item.label"
                :label="showDotText(item.label) + '  (' + item.value + ')'"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-collapse-item>
          <el-collapse-item :title="$t('RiskScan.ComplianceRisk')" name="8">
            <el-select
              clearable
              multiple
              v-model="searchParams.complianceRisk"
              filterable
              popper-class="new-search-select"
              :popper-append-to-body="true"
              :disabled="selectDisabled"
              :placeholder="$t('RiskScan.Selectrisklevel')"
              @change="(val) => onChangeParams(val, 'complianceRisk')"
            >
              <el-option
                v-for="(item, index) in complianceRiskList"
                :key="item.label"
                :label="showDotText(item.label) + '  (' + item.value + ')'"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-collapse-item>
          <el-collapse-item :title="$t('RiskScan.SustainabilityRisk')" name="9">
            <el-select
              clearable
              multiple
              v-model="searchParams.sustainabilityRisk"
              filterable
              popper-class="new-search-select"
              :popper-append-to-body="true"
              :disabled="selectDisabled"
              :placeholder="$t('RiskScan.Selectrisklevel')"
              @change="(val) => onChangeParams(val, 'sustainabilityRisk')"
            >
              <el-option
                v-for="(item, index) in sustainabilityRiskList"
                :key="item.label"
                :label="showDotText(item.label) + '  (' + item.value + ')'"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-collapse-item>
          <el-collapse-item :title="$t('RiskScan.IndustryRisk')" name="10">
            <el-select
              clearable
              multiple
              v-model="searchParams.industryRisk"
              filterable
              popper-class="new-search-select"
              :popper-append-to-body="true"
              :disabled="selectDisabled"
              :placeholder="$t('RiskScan.Selectrisklevel')"
              @change="(val) => onChangeParams(val, 'industryRisk')"
            >
              <el-option
                v-for="(item, index) in industryRiskList"
                :key="item.label"
                :label="showDotText(item.label) + '  (' + item.value + ')'"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-collapse-item>
        </el-collapse>
      </div>

      <div class="wrap_con_box">
        <template v-if="isHome">
          <div class="table_header">
            <div class="table_header_title">
              {{ $t("RiskScan.RiskScanning") }}
            </div>
            <div class="table_header_menus">
              <div class="display_switch">
                <div @click="changeSwitch(false)" :class="{ active: !isHome }">
                  <i class="iconfont icon-24gl-table" />
                </div>
                <div @click="changeSwitch(true)" :class="{ active: isHome }">
                  <i class="iconfont icon-shujulaiyuan" />
                </div>
              </div>
            </div>
          </div>
          <div class="risk_big_date">
            <div
              class="risk_big_data_item"
              v-for="(ris, index) in homeRiskData"
              :key="index"
            >
              <div class="risk_big_data_item_title">{{ $t(ris.title) }}</div>
              <div class="risk_big_data_item_list">
                <div class="risk_big_data_item_list_label">
                  <div class="dot" style="background-color: #00c924" />
                  {{ $t(ris.good.name) }}
                </div>
                <div
                  class="risk_big_data_item_list_value"
                  :class="
                    ris.good.len > 0
                      ? 'risk_big_data_item_list_value_point'
                      : ''
                  "
                  @click="ris.good.len > 0 ? showRiskDetail(ris, 1, true) : ''"
                >
                  {{ ris.good.len }}
                </div>
              </div>
              <div class="risk_big_data_item_list">
                <div class="risk_big_data_item_list_label">
                  <div class="dot" style="background-color: #ffc000" />
                  {{ $t(ris.medium.name) }}
                </div>
                <div
                  class="risk_big_data_item_list_value"
                  :class="
                    ris.medium.len > 0
                      ? 'risk_big_data_item_list_value_point'
                      : ''
                  "
                  @click="
                    ris.medium.len > 0 ? showRiskDetail(ris, 2, true) : ''
                  "
                >
                  {{ ris.medium.len }}
                </div>
              </div>
              <div class="risk_big_data_item_list">
                <div class="risk_big_data_item_list_label">
                  <div class="dot" style="background-color: #f00000" />
                  {{ $t(ris.bad.name) }}
                </div>
                <div
                  class="risk_big_data_item_list_value"
                  :class="
                    ris.bad.len > 0 ? 'risk_big_data_item_list_value_point' : ''
                  "
                  @click="ris.bad.len > 0 ? showRiskDetail(ris, 3, true) : ''"
                >
                  {{ ris.bad.len }}
                </div>
              </div>
              <div class="risk_big_data_item_list">
                <div class="risk_big_data_item_list_label">
                  <div class="dot" />
                  {{ $t(ris.unknown.name) }}
                </div>
                <div
                  class="risk_big_data_item_list_value"
                  :class="
                    ris.unknown.len > 0
                      ? 'risk_big_data_item_list_value_point'
                      : ''
                  "
                  @click="
                    ris.unknown.len > 0 ? showRiskDetail(ris, 4, true) : ''
                  "
                >
                  {{ ris.unknown.len }}
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="table_header">
            <div class="table_header_title">
              <i
                v-show="isShowBack"
                class="iconfont icon-fanhui margin-right15"
                style="color: #1290c9; font-size: 26px; cursor: pointer"
                @click="hideRiskDetail"
              ></i
              >{{ $t("RiskScan.RiskScanning") }}
            </div>
            <div class="table_header_menus" v-show="!isShowBack">
              <el-button
                type="text"
                @click="riskScanDialogOptionVisible = true"
                >{{ $t("RiskScan.Reselect") }}</el-button
              >
              <el-button type="text" @click="linkToRiskHistory">{{
                $t("RiskScan.HistoricalRecords")
              }}</el-button>
              <el-button type="text" disabled>{{
                $t("RiskScan.DownloadReport")
              }}</el-button>
              <el-button
                type="text"
                @click="linkToLeads"
                :disabled="!(selectList.length == 1 && isShowSelect)"
                >{{ $t("RiskScan.SearchLeads") }}</el-button
              >
              <div class="display_switch">
                <div @click="changeSwitch(false)" :class="{ active: !isHome }">
                  <i class="iconfont icon-24gl-table" />
                </div>
                <div @click="changeSwitch(true)" :class="{ active: isHome }">
                  <i class="iconfont icon-shujulaiyuan" />
                </div>
              </div>
            </div>
          </div>
          <el-table
            class="risk_table"
            :data="tableData"
            height="100%"
            ref="tableRef"
            v-loading="tableLoading"
            :row-key="(row) => row.aaaId"
            @expand-change="onRowExpansion"
            :expand-row-keys="expandedRowKeys"
            @selection-change="onSelectionChange"
          >
            <el-table-column
              v-if="isShowSelect"
              :resizable="false"
              type="selection"
              reserve-selection
              align="center"
              class-name="table_check_row"
              width="40"
            />

            <el-table-column
              type="expand"
              align="center"
              width="25"
              :resizable="false"
            >
              <template slot-scope="scope">
                <div class="expand_table_box">
                  <div class="flex_row">
                    <div class="expand_item">
                      <div
                        class="expand_item_title"
                        :style="{
                          color: showDot(scope.row.companyLegalRiskCode),
                        }"
                      >
                        {{ $t("RiskScan.LegalRisk") }}
                      </div>
                      <div class="expand_item_con_box">
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.CompanyID") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{ tableDetail?.companyLegalRiskVO?.companyId }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.CompanyType") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companyLegalRiskVO
                                ?.companyTypeCodeDescEn
                            }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.RegistrationDate") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companyLegalRiskVO?.registrationDate
                            }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.RegistrationStatus") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companyLegalRiskVO
                                ?.registrationStatus
                            }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.Listed") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{ tableDetail?.companyLegalRiskVO?.listed }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.LegalStatus") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{ tableDetail?.companyLegalRiskVO?.legalStatus }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="expand_item">
                      <div
                        class="expand_item_title"
                        :style="{
                          color: showDot(scope.row.companyOrgStructureRiskCode),
                        }"
                      >
                        {{ $t("RiskScan.OrganizationalRisk") }}
                      </div>
                      <div class="expand_item_con_box">
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.NoofShareholders") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companyOrgStructureRiskVO
                                ?.shareholders
                            }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.ShareholdingLayers") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companyOrgStructureRiskVO
                                ?.shareholdingLayers
                            }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.NoofCorporateShareholders") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companyOrgStructureRiskVO
                                ?.corporateShareholders
                            }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.NoofNatualPersonShareholders") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companyOrgStructureRiskVO
                                ?.individualShareholders
                            }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.RelatedCompanies") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companyOrgStructureRiskVO
                                ?.relatedCompanies
                            }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.OrganizationalStatus") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companyOrgStructureRiskVO
                                ?.organizationalStatusEn
                            }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="expand_item">
                      <div
                        class="expand_item_title"
                        :style="{
                          color: showDot(scope.row.companyOperatingRiskCode),
                        }"
                      >
                        {{ $t("RiskScan.OperationalRisk") }}
                      </div>
                      <div class="expand_item_con_box">
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.OperatingAddress") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companyOperatingRiskVO
                                ?.operatingAddressVefified
                            }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.IndustryCode") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companyOperatingRiskVO?.industryCode
                            }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.BusinessActivities") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companyOperatingRiskVO
                                ?.businessActivities
                            }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.NoofEmployees") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{ tableDetail?.companyOperatingRiskVO?.employees }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.Management") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companyOperatingRiskVO
                                ?.managementStatus
                            }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.CurrentOperations") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companyOperatingRiskVO
                                ?.currentOperationsStatus
                            }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="expand_item">
                      <div
                        class="expand_item_title"
                        :style="{
                          color: showDot(scope.row.companyFinancialRiskCode),
                        }"
                      >
                        {{ $t("RiskScan.FinancialRisk") }}
                      </div>
                      <div class="expand_item_con_box">
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.Revenue") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{ tableDetail?.companyFinancialRiskVO?.revenue }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.Assests") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{ tableDetail?.companyFinancialRiskVO?.assests }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.ProfitLoss") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companyFinancialRiskVO?.profitOrLoss
                            }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.Liquidity") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{ tableDetail?.companyFinancialRiskVO?.liquidity }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.Growth") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{ tableDetail?.companyFinancialRiskVO?.growth }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.Performance") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companyFinancialRiskVO?.performance
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="flex_row">
                    <div class="expand_item">
                      <div
                        class="expand_item_title"
                        :style="{
                          color: showDot(scope.row.companyCreditRiskCode),
                        }"
                      >
                        {{ $t("RiskScan.CreditRisk") }}
                      </div>
                      <div class="expand_item_con_box">
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.CreditRating") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{ tableDetail?.companyCreditRiskVO?.creditRating }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.CreditScore") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{ tableDetail?.companyCreditRiskVO?.creditScore }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.PausibilityofDefault") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{ tableDetail?.companyCreditRiskVO?.pd }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.SolvencyIndex") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companyCreditRiskVO?.solvencyIndex
                            }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.DebtCollection") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companyCreditRiskVO?.debtCollection
                            }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.CreditOpinion") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{ tableDetail?.companyCreditRiskVO?.riskIndex }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="expand_item">
                      <div
                        class="expand_item_title"
                        :style="{
                          color: showDot(scope.row.companyComplianceRiskCode),
                        }"
                      >
                        {{ $t("RiskScan.ComplianceRisk") }}
                      </div>
                      <div class="expand_item_con_box">
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.CompanySanction") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companyComplianceRiskVO
                                ?.companySanction
                            }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.ProductSanction") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companyComplianceRiskVO
                                ?.productSanction
                            }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.ExportControl") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companyComplianceRiskVO
                                ?.exportControl
                            }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.AntiCorruptionAntiBribery") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companyComplianceRiskVO
                                ?.antiCorruptionAndBribery
                            }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.Litigations") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companyComplianceRiskVO?.litigations
                            }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.NegativeNews") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companyComplianceRiskVO?.negativeNews
                            }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="expand_item">
                      <div
                        class="expand_item_title"
                        :style="{
                          color: showDot(
                            scope.row.companySustainabilityRiskCode,
                          ),
                        }"
                      >
                        {{ $t("RiskScan.SustainabilityRisk") }}
                      </div>
                      <div class="expand_item_con_box">
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.ESGScore") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companySustainabilityRiskVO
                                ?.ratingESG
                            }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.YearsinBusiness") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companySustainabilityRiskVO
                                ?.yearsInBusiness
                            }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.Competitiveness") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companySustainabilityRiskVO
                                ?.competitiveness
                            }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.WorkingCapital") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companySustainabilityRiskVO
                                ?.workingCapital
                            }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.FinancialStructure") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companySustainabilityRiskVO
                                ?.financialStructure
                            }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.Industrystatus") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companySustainabilityRiskVO?.growth
                            }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="expand_item">
                      <div
                        class="expand_item_title"
                        :style="{
                          color: showDot(scope.row.companyIndustryRiskCode),
                        }"
                      >
                        {{ $t("RiskScan.IndustryRisk") }}
                      </div>
                      <div class="expand_item_con_box">
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.IndustryOutlook") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companyIndustryRiskVO
                                ?.industryForecast
                            }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.NoofCompanies") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companyIndustryRiskVO
                                ?.companiesOfIndustry
                            }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.IndustryRanking") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companyIndustryRiskVO
                                ?.industryPosition
                            }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.IndustryConcentration") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companyIndustryRiskVO
                                ?.industryCentralization
                            }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.IndustryCompetitiveness") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companyIndustryRiskVO
                                ?.industryCompetition
                            }}
                          </div>
                        </div>
                        <div class="expand_item_list">
                          <div class="expand_item_list_label">
                            {{ $t("RiskScan.IndustryDevelopment") }}
                          </div>
                          <div class="expand_item_list_value">
                            {{
                              tableDetail?.companyIndustryRiskVO
                                ?.industryDevelopment
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="companyName"
              :label="$t('RiskScan.CompanyName')"
              min-width="300"
            >
              <template slot-scope="scope">
                <span
                  class="link_text"
                  @click="!!scope.row.aaaId ? onGoPage(scope.row) : ''"
                  >{{ scope.row.companyName }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="reportYear"
              align="center"
              :label="$t('RiskScan.LastUpdate')"
              min-width="110"
              ><template slot-scope="scope">
                <span
                  :style="scope.row.updateFlag == '1' ? 'color:#FF8200' : ''"
                  >{{ formatDate(scope.row.reportYear) }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="legalCode"
              align="center"
              :label="$t('RiskScan.Legal')"
              min-width="90"
            >
              <template slot-scope="scope">
                <div
                  :style="{
                    background: showDot(scope.row.companyLegalRiskCode),
                  }"
                  class="table_cell_dot"
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="organizationalCode"
              :label="$t('RiskScan.Organizational')"
              align="center"
              min-width="145"
            >
              <template slot-scope="scope">
                <div
                  :style="{
                    background: showDot(scope.row.companyOrgStructureRiskCode),
                  }"
                  class="table_cell_dot"
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="operatingCode"
              align="center"
              :label="$t('RiskScan.Operational')"
              min-width="120"
            >
              <template slot-scope="scope">
                <div
                  :style="{
                    background: showDot(scope.row.companyOperatingRiskCode),
                  }"
                  class="table_cell_dot"
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="financialCode"
              align="center"
              :label="$t('RiskScan.Financial')"
              min-width="100"
            >
              <template slot-scope="scope">
                <div
                  :style="{
                    background: showDot(scope.row.companyFinancialRiskCode),
                  }"
                  class="table_cell_dot"
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="creditCode"
              align="center"
              :label="$t('RiskScan.Credit')"
              min-width="115"
            >
              <template slot-scope="scope">
                <div
                  :style="{
                    background: showDot(scope.row.companyCreditRiskCode),
                  }"
                  class="table_cell_dot"
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="complianceCode"
              align="center"
              :label="$t('RiskScan.Compliance')"
              min-width="125"
            >
              <template slot-scope="scope">
                <div
                  :style="{
                    background: showDot(scope.row.companyComplianceRiskCode),
                  }"
                  class="table_cell_dot"
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="sustainabilityCode"
              :label="$t('RiskScan.Sustainability')"
              align="center"
              min-width="140"
            >
              <template slot-scope="scope">
                <div
                  :style="{
                    background: showDot(
                      scope.row.companySustainabilityRiskCode,
                    ),
                  }"
                  class="table_cell_dot"
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="industryCode"
              align="center"
              :label="$t('RiskScan.Industry')"
              min-width="95"
            >
              <template slot-scope="scope">
                <div
                  :style="{
                    background: showDot(scope.row.companyIndustryRiskCode),
                  }"
                  class="table_cell_dot"
                />
              </template>
            </el-table-column>
            <el-table-column align="center" label="" min-width="50">
              <template slot-scope="scope">
                <el-popover
                  popper-class="table_popover"
                  trigger="hover"
                  effect="light"
                  :content="$t('RiskScan.Download')"
                  placement="top"
                  :visible-arrow="false"
                >
                  <i
                    slot="reference"
                    class="iconfont icon-xiazai"
                    @click="exportReport(scope.row.aaaId)"
                  ></i>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination_box">
            <Page
              :keyword="$t('RiskScan.RiskScanning')"
              :fontColor="'#1290C9'"
              :total="total"
              :pageSize="
                !isShowBack ? searchParams.pageSize : searchRiskDetail.pageSize
              "
              :currentPage="
                !isShowBack
                  ? searchParams.currentPage
                  : searchRiskDetail.currentPage
              "
              @onPageChange="onChangePage"
            ></Page>
          </div>
        </template>
      </div>
    </div>

    <!-- 风险扫描提示弹窗 -->
    <el-dialog
      append-to-body
      title=""
      :visible.sync="riskScanDialogVisible"
      :before-close="
        () => {
          riskScanDialogVisible = false;
        }
      "
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      class="dialog_modal dialog_800"
      center
    >
      <div class="dialog_content">
        <div class="dialog_title_img">
          <img src="@/assets/images/risk_scan.png" />
        </div>
        <div class="dialog_title_img_text">{{ $t("RiskScan.RiskScan") }}</div>
        <div class="risk_desc">
          <span
            ><span class="blod">{{ $t("RiskScan.RiskScan") }} </span
            >{{ $t("RiskScan.RiskScanInfo") }}
          </span>
          <ul>
            <li>
              <span class="blod">{{ $t("RiskScan.LegalRisk") }}: </span
              >{{ $t("RiskScan.LegalRiskInfo") }}
            </li>
            <li>
              <span class="blod">{{ $t("RiskScan.OrganizationalRisk") }}: </span
              >{{ $t("RiskScan.OrganizationalRiskInfo") }}
            </li>
            <li>
              <span class="blod">{{ $t("RiskScan.OperationalRisk") }}: </span
              >{{ $t("RiskScan.OperationalRiskInfo") }}
            </li>
            <li>
              <span class="blod">{{ $t("RiskScan.FinancialRisk") }}: </span
              >{{ $t("RiskScan.FinancialPerformanceRiskInfo") }}
            </li>
            <li>
              <span class="blod">{{ $t("RiskScan.CreditRisk") }}: </span
              >{{ $t("RiskScan.CreditRiskInfo") }}
            </li>
            <li>
              <span class="blod">{{ $t("RiskScan.ComplianceRisk") }}: </span
              >{{ $t("RiskScan.ComplianceRiskInfo") }}
            </li>
            <li>
              <span class="blod">{{ $t("RiskScan.SustainabilityRisk") }}: </span
              >{{ $t("RiskScan.SustainabilityRiskInfo") }}
            </li>
            <li>
              <span class="blod">{{ $t("RiskScan.IndustryRisk") }}: </span
              >{{ $t("RiskScan.IndustryRiskInfo") }}
            </li>
          </ul>
          <span>{{ $t("RiskScan.Uploadyourlistofcompanies") }}</span>
        </div>
        <el-button
          class="risk_begin_btn"
          @click="
            (riskScanDialogOptionVisible = true),
              (riskScanDialogVisible = false)
          "
          >{{ $t("RiskScan.LetBegin") }}</el-button
        >
      </div>
    </el-dialog>
    <!-- 风险扫描操作弹窗 -->
    <el-dialog
      append-to-body
      title=""
      :visible.sync="riskScanDialogOptionVisible"
      :before-close="
        () => {
          riskScanDialogOptionVisible = false;
        }
      "
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      class="dialog_modal dialog_800"
      center
    >
      <div class="dialog_content">
        <div class="dialog_title_img">
          <img src="@/assets/images/risk_down_icon.png" />
        </div>
        <div class="risk_options_box">
          <div class="risk_list">
            <div class="risk_list_text">
              1. {{ $t("RiskScan.AddcompaniesfromSearchResult") }}
            </div>
            <el-button
              class="risk_chosen_btn"
              type="primary"
              @click="
                $router.push({
                  path: '/home',
                })
              "
              >{{ $t("RiskScan.Select") }}
            </el-button>
          </div>
          <div class="risk_list">
            <div class="risk_list_text">
              2. {{ $t("RiskScan.AddcompaniesfromMyDatabase") }}
            </div>
            <el-button
              class="risk_chosen_btn"
              @click="
                $router.push({
                  path: '/account/companiesViewed?type=1',
                })
              "
            >
              <i class="iconfont icon-queren" />{{ $t("RiskScan.Select") }}
            </el-button>
          </div>
          <div class="risk_list">
            <div class="risk_list_text">
              3. {{ $t("RiskScan.Addcompaniesbyuploadmyownlist") }}
            </div>
            <el-button class="risk_chosen_btn" @click="openUpload"
              >{{ $t("RiskScan.Upload") }}
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 扫描中动画 -->
    <el-dialog
      title=""
      class="dialog_550 dialog_modal dialog_riskHome"
      :visible.sync="loadingVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="closeLoadDialog"
    >
      <div class="dialog_content">
        <div class="dialog_title_tips">
          {{ $t("RiskScan.Datascanningisinprogress") }}
        </div>
        <div class="loading_box">
          <div class="loading_bg"></div>
          <div class="loading_num">{{ loadingNum }}%</div>
        </div>
      </div>
    </el-dialog>

    <!-- 提示选择多少条 -->
    <el-dialog
      append-to-body
      title=""
      :visible.sync="riskScanDialogVisible2"
      :before-close="
        () => {
          riskScanDialogVisible2 = false;
        }
      "
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      class="dialog_modal dialog_550"
      center
    >
      <div class="dialog_content">
        <div class="dialog_title_img">
          <img src="@/assets/images/risk_search_icon.png" />
        </div>
        <div class="dialog_title_img_text">
          {{ $t("RiskScan.RiskScanning") }}
        </div>
        <div class="risk_text">
          {{ $t("RiskScan.Youhaveselectedatotalof") }}
          <span class="num">{{ 100 }}</span>
          {{ $t("RiskScan.Tostartriskscanning") }}
        </div>
      </div>

      <div slot="footer" class="dialog_footer">
        <!-- <el-button
          @click="riskScanDialogVisible2 = false"
          class="risk_cancel_btn"
          type="cancel"
          >{{ $t("RiskScan.Cancel") }}</el-button
        > -->
        <el-button
          @click="riskScanDialogVisible2 = false"
          class="risk_primary_btn"
          type="primary"
          >{{ $t("RiskScan.Confirm") }}</el-button
        >
      </div>
    </el-dialog>

    <!-- 上传 -->
    <UpdateFile
      :isUploaded="true"
      :UpdateFileDialog="UpdateFileDialog"
      @closeUpDownDialog="onCloseUpDownDialog"
      @uploadSuccess="onUploadSuccess"
    ></UpdateFile>
  </div>
</template>
<script>
import tools from "@/views/layout/tools.vue";
import Page from "@/views/newLayout/page.vue";
import UpdateFile from "../myAccount/Database/adCppany/UpdateFile.vue";
import Tollbar from "@/views/newLayout/tollbar.vue";
import Header from "@/views/newLayout/header.vue";
import {
  beginScan,
  getRiskDataContent,
  staticRiskData,
  filterConditions,
  exportReport,
  searchData,
} from "@/api/companyApi";
import { downloadOnlinePdf } from "@/api/userApi";

export default {
  name: "RiskScanningHistory",
  data() {
    return {
      loadingVisible: false,
      loadingNum: 0,
      innerPercent: 0,
      startTime: 0,
      totalCount: 0, // 传入数量
      maxCount: 200,
      maxTime: 30000, // 30s
      riskScanDialogVisible: false,
      riskScanDialogOptionVisible: false,
      riskScanDialogVisible2: false,
      UpdateFileDialog: false,
      tableLoading: false,
      // 大数据风险扫描-首页数据
      homeRiskData: [],

      isHome: false,
      searchForm: {
        date: [],
      },
      tableData: [],
      tableSwitchData: [],
      total: 0,
      expandedRowKeys: [], // 当前展开的行的 key
      tableDetail: [],
      searchParams: {
        isHistory: 0,
        currentPage: 1,
        pageSize: 10,
        companyName: "",
        updateDate: "",
        scanTime: [],
        updateFlag: "1",
        legalRisk: [],
        organizationalRisk: [],
        operationalRisk: [],
        financialRisk: [],
        creditRisk: [],
        complianceRisk: [],
        sustainabilityRisk: [],
        industryRisk: [],
      },
      openMenu: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
      UpdateDateList: [
        { label: "High", value: "high" },
        { label: "Medium", value: "medium" },
        { label: "Low", value: "low" },
      ],
      companyNameList: [],
      legalRiskList: [],
      organizationalRiskList: [],
      operationalRiskList: [],
      financialRiskList: [],
      creditRiskList: [],
      complianceRiskList: [],
      sustainabilityRiskList: [],
      industryRiskList: [],
      conditionsList: ["Company Name", "Country", "Record Source"],
      selectList: [],
      isShowSearch: true, //默认展示侧边检索
      isShowSelect: false, // 是否显示复选框
      selectDisabled: false, //select 禁用
      isShowBack: false, //是否显示返回键
      searchRiskDetail: {
        //统计详细查询条件
        isHistory: 0,
        currentPage: 1,
        pageSize: 10,
        aaaids: [],
        legalRisk: [],
        organizationalRisk: [],
        operationalRisk: [],
        financialRisk: [],
        creditRisk: [],
        complianceRisk: [],
        sustainabilityRisk: [],
        industryRisk: [],
      },
    };
  },
  components: {
    Header,
    tools,
    Page,
    Tollbar,
    UpdateFile,
  },
  computed: {
    tollbarList() {
      return [
        {
          icon: "icon-xuanze",
          name: this.$t("Toolbar.Select"),
          disabled: false,
        },
        {
          icon: "icon-bianji1",
          name: this.$t("Toolbar.Edit"),
          disabled: true,
          select: true,
        },
        {
          icon: "icon-filter",
          name: this.$t("Toolbar.Sortby"),
          disabled: true,
          select: true,
        },
        {
          icon: "icon-shoucang1",
          name: this.$t("Toolbar.Collect"),
          disabled: true,
          select: true,
        },
        {
          icon: "icon-baocun",
          name: this.$t("Toolbar.Saved"),
          disabled: true,
          select: true,
        },
        {
          icon: "icon-icon_xinyong_xianxing_jijin-307",
          name: this.$t("Toolbar.Compare"),
          disabled: true,
        },
        {
          icon: "icon-daochu04",
          name: this.$t("Toolbar.Export"),
          disabled: true,
        },
        {
          icon: "icon-xiazai",
          name: this.$t("Toolbar.Download"),
          disabled: true,
        },
        {
          icon: "icon-shuaxin",
          name: this.$t("Toolbar.Update"),
          disabled: true,
        },
        {
          icon: "icon-judan",
          name: this.$t("Toolbar.Reporterror"),
          disabled: true,
        },
        {
          icon: "icon-gudong",
          name: this.$t("Toolbar.Share"),
          disabled: true,
        },
      ];
    },
    sortList() {
      return [
        {
          value: "",
          label: "Default",
        },
        {
          value: "1",
          label: this.$t("Toolbar.ascending"),
        },
        {
          value: "2",
          label: this.$t("Toolbar.descending"),
        },
      ];
    },
    showDot() {
      return (value) => {
        if (value === "1") {
          return "#3fb92f";
        } else if (value === "2") {
          return "#ff8200";
        } else if (value === "3") {
          return "#ec1a1a";
        } else {
          return "#999999";
        }
      };
    },
    showDotText() {
      return (value) => {
        if (value === "1") {
          return this.$t("RiskScan.Low");
        } else if (value === "2") {
          return this.$t("RiskScan.Average");
        } else if (value === "3") {
          return this.$t("RiskScan.Caution");
        } else {
          return this.$t("RiskScan.NotRated");
        }
      };
    },
  },
  watch: {
    loadingNum(val) {
      if (val >= 99 && this.total > 0) {
        this.finishLoading();
      }
    },
    isShowSelect(val) {
      if (!val) {
        this.tollbarList.forEach((item) => {
          if (item.name == "Export") {
            item.disabled = true;
          }
        });
      } else {
        if (this.selectList.length > 0) {
          this.tollbarList.forEach((item) => {
            if (item.name == "Export") {
              item.disabled = false;
            }
          });
        }
      }
    },
  },
  mounted() {
    if (this.$route.query.aaaids) {
      // this.searchParams.aaaids =
      //   JSON.parse(this.$route.query.aaaids).split("@@") || [];
      this.searchParams.aaaids = this.$route.query.aaaids.split("@@") || [];
      // 模拟扫描进度
      this.loadingVisible = true;
      this.startLoading(this.searchParams.aaaids.length);
      this.getBeginScan();
    } else {
      this.riskScanDialogVisible = true;
    }
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer);
  },
  methods: {
    formatDate(dateString) {
      const options = { year: "numeric", month: "2-digit", day: "2-digit" };
      return new Date(dateString).toLocaleDateString("en-CA", options);
    },
    formatDateToMDY() {
      const now = new Date();
      const month = (now.getMonth() + 1).toString().padStart(2, "0"); // 月份从0开始，需要+1
      const day = now.getDate().toString().padStart(2, "0");
      const year = now.getFullYear();
      return `${month}${day}${year}`;
    },
    // 扫描开场动画 最长30s 最少900ms  根据扫描公司的数量决定时间  最多200家公司 接口未完成时停留在99%
    startLoading(count) {
      clearInterval(this.timer);
      this.loadingNum = 0;
      this.innerPercent = 0;
      const safeCount = Number(count) || 1;
      const rawTime = (safeCount / this.maxCount) * this.maxTime;
      const minTime = 900;
      const safeTime = Math.max(rawTime, minTime);
      const interval = 300;
      const step = 99 / (safeTime / interval);

      this.timer = setInterval(() => {
        if (this.innerPercent < 99) {
          this.innerPercent += step;
          // 显示时取整
          this.loadingNum = Math.min(Math.floor(this.innerPercent), 99);
        }
      }, interval);
    },
    finishLoading() {
      clearInterval(this.timer);
      this.loadingNum = 100;
      setTimeout(() => {
        this.closeLoadDialog();
      }, 300);
    },
    closeLoadDialog() {
      this.loadingVisible = false;
      clearInterval(this.timer);
    },
    // 点击菜单回调 控制检索
    changeSwitch(val) {
      this.selectDisabled = val;
      this.clearParams();
      this.tableLoading = true;
      if (val) {
        let aaa_id = this.searchParams.aaaids;
        const params = {
          page: this.searchParams.currentPage,
          pageSize: this.searchParams.pageSize,
          aaaIds: aaa_id,
        };
        staticRiskData(params)
          .then((res) => {
            if (res && res.code) {
              // this.tableSwitchData=res.data
              this.homeRiskData = [];
              this.searchRiskDetail.aaaids = res.data.aaaIds;
              let list = res.data;
              const nameList = [
                // "Risk Scanning Statistics",
                "RiskScan.LegalRisk",
                "RiskScan.OrganizationalRisk",
                "RiskScan.OperationalRisk",
                "RiskScan.FinancialRisk",
                "RiskScan.CreditRisk",
                "RiskScan.ComplianceRisk",
                "RiskScan.SustainabilityRisk",
                "RiskScan.IndustryRisk",
              ];
              const valueList = [
                // "riskScanningStatistics",
                "legalRisk",
                "organizationalRisk",
                "operationalRisk",
                "financialRisk",
                "creditRisk",
                "complianceRisk",
                "sustainabilityRisk",
                "industryRisk",
              ];
              let objList = [];
              for (var i = 0; i < 8; i++) {
                let obj = {};
                obj.title = nameList[i];
                obj.good = {
                  name: "RiskScan.Low",
                  len: list[valueList[i]].good,
                };
                obj.medium = {
                  name: "RiskScan.Average",
                  len: list[valueList[i]].general,
                };
                obj.bad = {
                  name: "RiskScan.Caution",
                  len: list[valueList[i]].differ,
                };
                obj.unknown = {
                  name: "RiskScan.NotRated",
                  len: list[valueList[i]].notEvaluated,
                };
                objList.push(obj);
              }
              this.homeRiskData = objList;
              this.tableLoading = false;
            }
          })
          .catch((res) => {});
      } else {
        this.tableLoading = false;
        // this.getPageList();
      }
      this.isHome = val;
      this.reportyear = null;
    },
    // 工具栏点击
    onSearch(params) {},
    // 清空排序
    onChangeSort(e) {},
    // 清空
    clearParams() {
      let aaaidList = this.searchParams.aaaids;
      this.searchParams = {
        isHistory: 0,
        currentPage: 1,
        pageSize: 10,
        companyName: "",
        scanTime: [],
        updateDate: "",
        updateFlag: "1",
        legalRisk: [],
        organizationalRisk: [],
        operationalRisk: [],
        financialRisk: [],
        creditRisk: [],
        complianceRisk: [],
        sustainabilityRisk: [],
        industryRisk: [],
        aaaids: aaaidList,
      };
      this.getPageList();
    },
    // 清空统计查询条件
    clearRiskParams() {
      let aaaidList = this.searchRiskDetail.aaaids;
      this.searchRiskDetail = {
        isHistory: 0,
        currentPage: 1,
        pageSize: 10,
        legalRisk: [],
        organizationalRisk: [],
        operationalRisk: [],
        financialRisk: [],
        creditRisk: [],
        complianceRisk: [],
        sustainabilityRisk: [],
        industryRisk: [],
        aaaids: aaaidList,
      };
    },
    // 检索
    onChangeParams(val, name) {
      this.searchParams.currentPage = 1;
      this.searchRiskDetail.currentPage = 1;
      this.getPageList();
    },
    // 时间选择
    filterDay() {},
    // 跳转历史数据
    linkToRiskHistory() {
      let routeData = this.$router.resolve({
        path: "/riskScanning/history",
      });
      window.open(routeData.href, "_blank");
    },
    // 跳转获客
    linkToLeads() {
      if (this.selectList.length < 1) {
        return;
      } else {
        let aaa_id = this.selectList[0].aaaId;
        let name_en = this.selectList[0].companyName;
        let country_code = this.selectList[0].countryCode;
        let routeData = this.$router.resolve({
          path: "/index/list/risk",
          query: {
            // aaa_id: aaa_id,
            // name_en: name_en,
            // country_code: country_code,
            selectCode: 4,
            aaa_id: aaa_id,
            companyName: name_en,
          },
        });
        window.open(routeData.href, "_blank");
      }
    },
    getBeginScan() {
      // 模拟获取数据的函数
      const params = {
        page: this.searchParams.currentPage,
        pageSize: this.searchParams.pageSize,
        aaaIds: this.searchParams.aaaids,
        // endDate: this.searchForm.date[1],
      };
      beginScan(params)
        .then((res) => {
          if (res && res.code) {
            this.getPageList();
          }
        })
        .catch((res) => {});
    },
    getPageList() {
      // 模拟获取数据的函数 searchData
      // let aaaIdlist=this.searchParams.aaaids.join(",")
      const params = {
        isHistory: 0,
        page: this.searchParams.currentPage,
        pageSize: this.searchParams.pageSize,
        // startTime: this.searchParams.scanTime[0],
        // endTime: this.searchParams.scanTime[1],
        companyName: this.searchParams.companyName,
        aaaIds: this.searchParams.aaaids,
        legalRisk: this.searchParams.legalRisk,
        organizationalRisk: this.searchParams.organizationalRisk,
        operationalRisk: this.searchParams.operationalRisk,
        financialRisk: this.searchParams.financialRisk,
        creditRisk: this.searchParams.creditRisk,
        complianceRisk: this.searchParams.complianceRisk,
        sustaninabilityRisk: this.searchParams.sustaninabilityRisk,
        industryRisk: this.searchParams.industryRisk,
        updateDate: this.searchParams.updateDate,
        needUpdate:
          this.searchParams.updateFlag === "1"
            ? ""
            : this.searchParams.updateFlag === "2"
            ? "1"
            : "0",
      };

      // 在这里调用API获取数据，并更新tableData和total
      searchData(params)
        .then((res) => {
          if (res && res.code) {
            this.tableData = res.data.rows;
            this.total = res.data.total;
            this.filterConditions();
            if (this.loadingNum >= 99) {
              this.finishLoading();
            }
          }
        })
        .catch((res) => {});
      // this.filterConditions();
      // this.tableData = this.localData.rows;
      // this.total = this.localData.total;
      // if (this.loadingNum >= 99) {
      //   this.finishLoading();
      // }
    },
    filterConditions() {
      // let aaaIdlist=this.searchParams.aaaids.join(",")
      let params = {
        isHistory: 0,
        aaaIds: this.searchParams.aaaids,
        legalRisk: this.searchParams.legalRisk,
        organizationalRisk: this.searchParams.organizationalRisk,
        operationalRisk: this.searchParams.operationalRisk,
        financialRisk: this.searchParams.financialRisk,
        creditRisk: this.searchParams.creditRisk,
        complianceRisk: this.searchParams.complianceRisk,
        sustaninabilityRisk: this.searchParams.sustainabilityRisk,
        industryRisk: this.searchParams.industryRisk,
        needUpdate:
          this.searchParams.updateFlag === "1"
            ? ""
            : this.searchParams.updateFlag === "2"
            ? "1"
            : "0",
      };

      filterConditions(params)
        .then((res) => {
          if (res && res.code) {
            this.UpdateDateList = res.data.updateDates;
            this.companyNameList = res.data.companyNameFilters;
            this.industryRiskList = res.data.industryRisk;
            this.sustainabilityRiskList = res.data.sustainabilityRisk;
            this.complianceRiskList = res.data.complianceRisk;
            this.creditRiskList = res.data.creditRisk;
            this.financialRiskList = res.data.financialRisk;
            this.operationalRiskList = res.data.operationalRisk;
            this.organizationalRiskList = res.data.organizationalRisk;
            this.legalRiskList = res.data.legalRisk;
          }
        })
        .catch((res) => {});
    },
    // 导出
    onExport() {
      if (this.selectList.length == 0) return;
      const params = this.selectList.map((item) => {
        return item.id;
      });
      exportReport({
        ids: params,
        isHistory: 0,
      })
        .then((res) => {
          const blob = new Blob([res], { type: "application/vnd.ms-excel" });
          const fileName = "Risk Scan " + this.formatDateToMDY() + ".xlsx"; // 文件名 Risk Scan+01292026
          const href = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = href;
          link.download = fileName; // 设置下载文件名
          link.click();
        })
        .catch((res) => {});
    },
    //下载
    exportReport(id) {
      downloadOnlinePdf(id)
        .then((res) => {
          const binaryData = [];
          binaryData.push(res);
          let pdfUrl = window.URL.createObjectURL(
            new Blob(binaryData, { type: "application/pdf" }),
          );
          window.open(pdfUrl, "_blank");
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },
    // 表格展开
    onRowExpansion(row) {
      this.tableDetail = [];
      this.$emit("selectTwoRow", []); //展开时清空所有选择项
      // 如果展开的行已存在于 expandedRowKeys 数组中，则关闭所有行
      if (this.expandedRowKeys.includes(row.aaaId)) {
        this.expandedRowKeys = [];
        return;
      } else {
        // 否则只展开当前行
        this.expandedRowKeys = [row.aaaId];
      }

      let param = {
        aaaId: row.aaaId,
      };
      getRiskDataContent(param)
        .then((res) => {
          if (res && res.code) {
            this.tableDetail = res.data;
          }
        })
        .catch((res) => {});
    },
    // 表格模式行选择改变时
    onSelectionChange(val) {
      this.selectList = val;
      if (val.length > 0 && this.isShowSelect) {
        this.tollbarList.forEach((item) => {
          if (item.name == "Export") {
            item.disabled = false;
          }
        });
      } else {
        this.tollbarList.forEach((item) => {
          if (item.name == "Export") {
            item.disabled = true;
          }
        });
      }
    },
    // 翻页
    onChangePage(pagParm) {
      if (!this.isShowBack) {
        this.searchParams.currentPage = pagParm.page;
        this.searchParams.pageSize = pagParm.pageSize;
        this.getPageList();
      } else {
        this.searchRiskDetail.currentPage = pagParm.page;
        this.searchRiskDetail.pageSize = pagParm.pageSize;
        this.showRiskDetail("", "", false);
      }
    },
    // 打开上传
    openUpload() {
      this.riskScanDialogOptionVisible = false;
      this.UpdateFileDialog = true;
    },
    // 关闭上传
    onCloseUpDownDialog() {
      this.UpdateFileDialog = false;
    },
    // 上传确认后后跳转到我的数据
    onUploadSuccess() {
      this.$router.push({
        path: "/account/companiesViewed",
        query: {
          type: 4,
        },
      });
    },
    showRiskDetail(item, type, ref) {
      this.tableLoading = true;
      this.isShowSearch = false;
      this.isShowBack = true;
      this.isHome = false;
      this.tableData = [];
      if (ref) {
        this.clearRiskParams();
        if (item.title == "Legal Risk") {
          this.searchRiskDetail.legalRisk.push(type);
        } else if (item.title == "Organizational Risk") {
          this.searchRiskDetail.organizationalRisk.push(type);
        } else if (item.title == "Operational Risk") {
          this.searchRiskDetail.operationalRisk.push(type);
        } else if (item.title == "Financial Risk") {
          this.searchRiskDetail.financialRisk.push(type);
        } else if (item.title == "Credit Risk") {
          this.searchRiskDetail.creditRisk.push(type);
        } else if (item.title == "Compliance Risk") {
          this.searchRiskDetail.complianceRisk.push(type);
        } else if (item.title == "Sustainability Risk") {
          this.searchRiskDetail.sustainabilityRisk.push(type);
        } else if (item.title == "Industry Risk") {
          this.searchRiskDetail.industryRisk.push(type);
        }
      }
      const params = {
        isHistory: 0,
        page: this.searchRiskDetail.currentPage,
        pageSize: this.searchRiskDetail.pageSize,
        aaaIds: this.searchRiskDetail.aaaids,
        legalRisk: this.searchRiskDetail.legalRisk,
        organizationalRisk: this.searchRiskDetail.organizationalRisk,
        operationalRisk: this.searchRiskDetail.operationalRisk,
        financialRisk: this.searchRiskDetail.financialRisk,
        creditRisk: this.searchRiskDetail.creditRisk,
        complianceRisk: this.searchRiskDetail.complianceRisk,
        sustaninabilityRisk: this.searchRiskDetail.sustainabilityRisk,
        industryRisk: this.searchRiskDetail.industryRisk,
      };

      // 在这里调用API获取数据，并更新tableData和total
      searchData(params)
        .then((res) => {
          if (res && res.code) {
            this.tableData = res.data.rows;
            this.total = res.data.total;
            this.tableLoading = false;
          }
        })
        .catch((res) => {});
    },
    hideRiskDetail() {
      this.isShowSearch = true;
      this.isShowBack = false;
      this.isHome = true;
      // this.clearParams();
      this.clearRiskParams();
    },
    onGoPage(row) {
      let routeData = this.$router.resolve({
        path:
          "/index/company/details/" +
          row.aaaId +
          "/background/snapshot?id3a=" +
          row.aaaId +
          "&companyCountry=" +
          row.countryCode +
          // "&SACode1=" +
          // SACode1 +
          "&companyName=" +
          row.companyName +
          "&keword=" +
          this.$route.query.keword,
      });

      window.open(routeData.href, "_blank");

      // let routeData = this.$router.resolve({
      //   path: "/sanction/companyDetail/sanction",
      //   query: {
      //     id3a: row.aaaid,
      //     id: row.id,
      //     keyword: this.$route.query.keyword,
      //     selectCode: 1,
      //   },
      // });
      // window.open(routeData.href, "_blank");
    },
  },
};
</script>
<style></style>
<style lang="css" scoped>
.risk_options_box {
  width: 100%;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.risk_list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100px;
  background: #f5f5f5;
  border-radius: 4px;
  padding: 30px 20px;
}
.risk_list_text {
  font-weight: bold;
  font-size: 24px;
  color: #1a2332;
  line-height: 40px;
  text-align: left;
}
.risk_chosen_btn {
  width: 120px;
  height: 40px;
  background: #1290c9;
  border-radius: 10px;
  font-weight: bold;
  font-size: 20px;
  color: #ffffff;
  line-height: 40px;
  text-align: center;
  padding: 0 !important;
  flex-shrink: 0;
}
.loading_box {
  width: 286px;
  height: 286px;
  overflow: hidden;
  position: relative;
  margin-top: 30px;
  margin-bottom: 10px;
  background-image: url("../../assets/images/loadingOut_bg.png");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loading_bg {
  margin: 0 auto;
  width: 192px;
  height: 192px;
  background-image: url("../../assets/images/loadingCon_bg.png");
  background-size: cover;
  background-position: center;
  animation: spin 3s linear infinite;
}
.loading_num {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-weight: bold;
  font-size: 40px;
  color: #ffffff;
  line-height: 80px;
  text-align: center;
}
.risk_desc li,
.risk_desc span {
  color: #666666;
}
.risk_desc .blod {
  color: #1290c9 !important;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.risk_big_date {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px 13px;
  overflow: auto;
  padding-bottom: 40px;
}
.risk_big_data_item {
  width: calc(25% - 10px);
  height: auto;
  background: linear-gradient(
    148deg,
    #d8efff 0.79%,
    #f2f6ff 56.64%,
    #d8efff 100%
  );
  border-radius: 10px;
  padding: 20px 30px;
}
.risk_big_data_item_title {
  font-family: "Arial Bold";
  font-size: 20px;
  color: #1a2332;
  line-height: 26px;
  text-align: left;
}
.risk_big_data_item_list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  gap: 40px;
}

.risk_big_data_item_list_label {
  font-weight: 400;
  font-size: 18px;
  color: #1a2332;
  line-height: 18px;
  text-align: left;
  font-style: normal;
  display: flex;
  align-items: center;
  gap: 10px;
}
.dot {
  width: 12px;
  height: 12px;
  background: #999999;
  border-radius: 50%;
}
.risk_big_data_item_list_value {
  flex: 1;
  width: 70px;
  height: 22px;
  font-family: "Arial Bold";
  font-size: 18px;
  color: #1290c9;
  line-height: 18px;
  text-align: right;
  font-style: normal;
}
.risk_big_data_item_list_value_point {
  cursor: pointer;
}
/* .dialog_modal /deep/ .el-dialog {
  margin: 9% auto !important;
} */
.risk_desc li::before {
  background-color: #666666;
}
@media (max-width: 1920px) {
  .risk_options_box {
    margin-top: 16px;
    gap: 16px;
  }
  .risk_list {
    height: 75px;
    padding: 22px 16px;
  }
  .risk_list_text {
    font-size: 18px;
    line-height: 30px;
  }
  .risk_chosen_btn {
    width: 100px;
    height: 32px;
    border-radius: 8px;
    font-size: 16px;
    line-height: 30px;
  }
  .loading_box {
    width: 220px;
    height: 220px;
    margin-top: 16px;
    margin-bottom: 8px;
  }
  .loading_bg {
    width: 150px;
    height: 150px;
  }
  .loading_num {
    font-size: 30px;
    line-height: 60px;
  }

  .risk_big_date {
    gap: 16px 10px;
    padding-bottom: 30px;
  }
  .risk_big_data_item {
    width: calc(25% - 8px);
    border-radius: 8px;
    padding: 16px 24px;
  }
  .risk_big_data_item_title {
    font-size: 16px;
    line-height: 20px;
  }
  .risk_big_data_item_list {
    margin-top: 16px;
    gap: 30px;
  }

  .risk_big_data_item_list_label {
    font-size: 16px;
    line-height: 16px;
    gap: 8px;
  }
  .dot {
    width: 10px;
    height: 10px;
  }
  .risk_big_data_item_list_value {
    flex: 1;
    width: 50px;
    height: 18px;
    font-size: 16px;
    line-height: 16px;
  }
  .dialog_800 /deep/ .el-dialog {
    width: 790px;
  }
  .risk_desc li {
    margin-left: 45px;
  }
  .risk_desc li::before {
    left: -22px;
  }
}
</style>
